import api, { V2_ADMIN_PREFIX } from '@/apis/api';
import type { PartnerListItem } from '@/types/partners';
import type { PaginationApiResponse } from '@/types/shared';
import { useQuery } from '@tanstack/react-query';

export const PARTNER_SEARCH_QUERY_KEY = 'partner_search';
const PARTNER_SEARCH_PAGE_SIZE = 100;

export const usePartnerSearchQuery = (debouncedSearchQuery: string) => {
  const trimmed = debouncedSearchQuery.trim();

  const { data, isLoading } = useQuery({
    queryKey: [PARTNER_SEARCH_QUERY_KEY, trimmed],
    queryFn: async () => {
      if (!trimmed) return [];
      const { data: res } = await api.get<PaginationApiResponse<PartnerListItem>>(`${V2_ADMIN_PREFIX}/partners`, {
        params: { size: PARTNER_SEARCH_PAGE_SIZE, search_query: trimmed },
      });
      return res.items;
    },
    enabled: trimmed.length > 0,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });

  return {
    partners: data ?? [],
    isLoading,
  };
};
